import * as packagesService from '@features/pickups/services/pickupService';

import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useGenerateBonDeLivraison = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => packagesService.generateBonDeLivraison(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pickups"] });
    },
    onError: (error) => {
      console.error("Failed to update package status:", error);
    },
  });
};
